import { SvgIconProps } from "@mui/material";

export const MultiplePagesOSIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="108"
    height="64"
    viewBox="0 0 108 64"
    fill="none"
    {...props}
  >
    <path
      d="M32.5 2.75V15.75C32.5 16.612 32.8424 17.4386 33.4519 18.0481C34.0614 18.6576 34.888 19 35.75 19H48.75"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.25 61.25H9.75C8.02609 61.25 6.37279 60.5652 5.15381 59.3462C3.93482 58.1272 3.25 56.4739 3.25 54.75V9.25C3.25 7.52609 3.93482 5.87279 5.15381 4.65381C6.37279 3.43482 8.02609 2.75 9.75 2.75H32.5L48.75 19V54.75C48.75 56.4739 48.0652 58.1272 46.8462 59.3462C45.6272 60.5652 43.9739 61.25 42.25 61.25Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g clipPath="url(#clip0_731_9444)">
      <path
        d="M24.375 28.75H39"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.375 38.5H39"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.375 48.25H39"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M88.5 2.75V15.75C88.5 16.612 88.8424 17.4386 89.4519 18.0481C90.0614 18.6576 90.888 19 91.75 19H104.75"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M98.25 61.25H65.75C64.0261 61.25 62.3728 60.5652 61.1538 59.3462C59.9348 58.1272 59.25 56.4739 59.25 54.75V9.25C59.25 7.52609 59.9348 5.87279 61.1538 4.65381C62.3728 3.43482 64.0261 2.75 65.75 2.75H88.5L104.75 19V54.75C104.75 56.4739 104.065 58.1272 102.846 59.3462C101.627 60.5652 99.9739 61.25 98.25 61.25Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g clipPath="url(#clip1_731_9444)">
      <path
        d="M80.375 28.75H95"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M80.375 38.5H95"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M80.375 48.25H95"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip2_731_9444)">
      <path
        d="M18.25 28.625C18.25 27.7962 17.9208 27.0013 17.3347 26.4153C16.7487 25.8292 15.9538 25.5 15.125 25.5H13.875C13.0462 25.5 12.2513 25.8292 11.6653 26.4153C11.0792 27.0013 10.75 27.7962 10.75 28.625V32.375C10.75 33.2038 11.0792 33.9987 11.6653 34.5847C12.2513 35.1708 13.0462 35.5 13.875 35.5H15.125C15.9538 35.5 16.7487 35.1708 17.3347 34.5847C17.9208 33.9987 18.25 33.2038 18.25 32.375V28.625Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip3_731_9444)">
      <path
        d="M17.625 44C17.625 43.337 17.3616 42.7011 16.8928 42.2322C16.4239 41.7634 15.788 41.5 15.125 41.5H13.875C13.212 41.5 12.5761 41.7634 12.1072 42.2322C11.6384 42.7011 11.375 43.337 11.375 44C11.375 44.663 11.6384 45.2989 12.1072 45.7678C12.5761 46.2366 13.212 46.5 13.875 46.5H15.125C15.788 46.5 16.4239 46.7634 16.8928 47.2322C17.3616 47.7011 17.625 48.337 17.625 49C17.625 49.663 17.3616 50.2989 16.8928 50.7678C16.4239 51.2366 15.788 51.5 15.125 51.5H13.875C13.212 51.5 12.5761 51.2366 12.1072 50.7678C11.6384 50.2989 11.375 49.663 11.375 49"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip4_731_9444)">
      <path
        d="M67.375 41.5H71.125C71.9538 41.5 72.7487 41.8292 73.3347 42.4153C73.9208 43.0013 74.25 43.7962 74.25 44.625V48.375C74.25 49.2038 73.9208 49.9987 73.3347 50.5847C72.7487 51.1708 71.9538 51.5 71.125 51.5H67.375V41.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip5_731_9444)">
      <path
        d="M74.25 28.625C74.25 27.7962 73.9208 27.0013 73.3347 26.4153C72.7487 25.8292 71.9538 25.5 71.125 25.5H69.875C69.0462 25.5 68.2513 25.8292 67.6653 26.4153C67.0792 27.0013 66.75 27.7962 66.75 28.625V32.375C66.75 33.2038 67.0792 33.9987 67.6653 34.5847C68.2513 35.1708 69.0462 35.5 69.875 35.5H71.125C71.9538 35.5 72.7487 35.1708 73.3347 34.5847C73.9208 33.9987 74.25 33.2038 74.25 32.375V28.625Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_731_9444">
        <rect
          width="39"
          height="39"
          fill="white"
          transform="translate(6.5 19)"
        />
      </clipPath>
      <clipPath id="clip1_731_9444">
        <rect
          width="39"
          height="39"
          fill="white"
          transform="translate(62.5 19)"
        />
      </clipPath>
      <clipPath id="clip2_731_9444">
        <rect width="15" height="15" fill="white" transform="translate(7 23)" />
      </clipPath>
      <clipPath id="clip3_731_9444">
        <rect width="15" height="15" fill="white" transform="translate(7 39)" />
      </clipPath>
      <clipPath id="clip4_731_9444">
        <rect
          width="15"
          height="15"
          fill="white"
          transform="translate(63 39)"
        />
      </clipPath>
      <clipPath id="clip5_731_9444">
        <rect
          width="15"
          height="15"
          fill="white"
          transform="translate(63 23)"
        />
      </clipPath>
    </defs>
  </svg>
);
